// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module_root-1GWoL"};